import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-22afc0c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-label" }
const _hoisted_2 = { class: "item-content" }
const _hoisted_3 = { class: "item-value" }

import Card from '@/views/dashboard/_components/card/card.vue'
import { getMonitorProgressColor } from '@/utils/monitor-progress'

export interface HardwareMonitorStatRow {
  label: string
  percent: number
  count: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'hardware-monitor-stat-card',
  props: {
    title: {},
    items: {}
  },
  setup(__props: any) {



function clampedPercent(p: number) {
  const n = Number(p)
  if (!Number.isFinite(n)) return 0
  return Math.min(100, Math.max(0, Math.round(n)))
}

return (_ctx: any,_cache: any) => {
  const _component_el_progress = _resolveComponent("el-progress")!

  return (_openBlock(), _createBlock(Card, {
    size: "second",
    class: "hardware-monitor-stat-card",
    title: _ctx.title
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (row, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: "card-item"
        }, [
          _createElementVNode("div", _hoisted_1, _toDisplayString(row.label), 1),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_progress, {
              percentage: clampedPercent(row.percent),
              "show-text": false,
              color: _unref(getMonitorProgressColor),
              class: "progress-bar"
            }, null, 8, ["percentage", "color"]),
            _createElementVNode("span", _hoisted_3, _toDisplayString(row.count), 1)
          ])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})